import React, { Component } from 'react'
import axios from 'axios'
import { Form, Text, TextArea } from 'react-form'
import PropTypes from 'prop-types'
import FormSuccess from '../success'
import IconInfo from '../../icons/info'

// HostGator returns 409 until this cookie exists. It is host-only, so the
// form must post to the same host that served the page.
const MAILER_PATH = '/mailer/mailer.php'

function rememberHuman() {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = 'humans_21909=1; path=/; Secure; SameSite=Lax';

  if (document.cookie.indexOf('humans_21909=') === -1) {
    document.cookie = 'humans_21909=1; path=/';
  }
}

function mailerOk(data) {
  return data === 'Message sent!'
    || (data && data.success === true)
    || (data && data.legacy === 'Message sent!');
}

function mailerMessage(error) {
  const data = error && error.response && error.response.data;

  if (data && typeof data === 'object' && (data.message || data.error)) {
    return data.message || data.error;
  }

  return 'Unable to send. Please call the shop or try again.';
}

class ContactForm extends Component {
  constructor() {
    super();

    this.state = {
      formComplete: false,
      isSubmitted: false,
      isSending: false,
      submitError: ''
    }

    this.renderForm = this.renderForm.bind(this);
  }

  postMailer = (payload, attempt) => {
    rememberHuman();

    return axios.post(MAILER_PATH, payload).catch((error) => {
      const status = error.response && error.response.status;

      if (!attempt && status === 409) {
        rememberHuman();
        return this.postMailer(payload, 1);
      }

      throw error;
    });
  }

  onFormSubmit = (values) => {
    const vm = this;
    const { name, phone, email, comment, location } = values;

    vm.setState({ isSending: true, submitError: '' });

    this.postMailer({
      name,
      email,
      phone,
      comment,
      location
    })
    .then((result) => {
      const data = result.data;

      if (mailerOk(data)) {
        vm.setState({
          isSubmitted: true,
          isSending: false,
          submitError: ''
        });
        return;
      }

      vm.setState({
        isSending: false,
        submitError: (data && (data.message || data.error)) || 'Unable to send. Please call the shop or try again.'
      });
    })
    .catch((error) => {
      vm.setState({
        isSending: false,
        submitError: mailerMessage(error)
      });
    });
  }

  onInvalid = (errors) => {
    const order = ['name', 'email', 'phone', 'location', 'comment'];
    const message = errors
      ? order.map((key) => errors[key]).filter(Boolean).join(' ')
      : '';

    this.setState({
      isSending: false,
      submitError: message || 'Fill in every field, then press send.'
    });
  }

  renderFormHeader = () => {
    if (!this.state.isSubmitted) {
      return (
        <div className="contact-form__header">
          <h4 className="contact-form__heading">
            {this.props.title ? this.props.title : 'appointments'}
          </h4>
          <div className="contact-form__message">
            <IconInfo />
            <p>Our appointment scheduling is now back online. We apologize for the inconvenience :)</p>
          </div>
        </div>
      )
    }
  }

  renderForm = () => {
    return (
      <div className="contact-form__form">
        <Form
          onSubmit={this.onFormSubmit}
          onSubmitFailure={this.onInvalid}
          validate={values => {
            const { name, phone, email, comment, location } = values;
            return {
              name: !name ? 'A name is required.' : undefined,
              email: !email ? 'An email is required.' : undefined,
              phone: !phone ? 'A phone number is required.' : undefined,
              comment: !comment ? 'Help us understand what you are looking for.' : undefined,
              location: !location ? 'A shop location is required.' : undefined,
            };
          }}
        >
          {({ values, submitForm, setValue, setTouched }) => {
            return (
              <form onSubmit={submitForm}>
                <Text placeholder="Name" field="name" />
                <Text placeholder="Email" field="email" type="email" />
                <Text placeholder="Phone" field="phone" type="tel" />
                <select
                  value={values.location || ''}
                  onChange={(event) => {
                    setValue('location', event.target.value);
                    setTouched('location');
                  }}
                >
                  <option value="">Preferred location</option>
                  <option value="East Bradenton">East Bradenton</option>
                  <option value="West Bradenton">West Bradenton</option>
                </select>
                <TextArea placeholder="Tell us about what you'd like done." field="comment" />
                {this.state.submitError && (
                  <p className="contact-form__error">{this.state.submitError}</p>
                )}
                <button
                  className="contact-form__button"
                  type="submit"
                  disabled={this.state.isSending}
                >
                  {this.state.isSending ? 'sending' : 'send'}
                </button>
              </form>
            );
          }}
        </Form>
      </div>
    );
  }

  render() {
    return (
      <div className="contact-form">
        { this.state.isSubmitted ? <FormSuccess /> : this.renderForm() }
      </div>
    )
  }
}

ContactForm.propTypes = {
  title: PropTypes.string
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/forms/contact/index.js